// extracted by mini-css-extract-plugin
export default {"title":"B9DQy","actions":"AGz3w","action":"cWbcR"};